'use strict';

var svaneTvis = svaneTvis || {};
var novicell = novicell || {};

svaneTvis.overlay = svaneTvis.overlay || new function () {

    this.init = function () {

        // Overlay
        const overlayTriggers = document.querySelectorAll('.js-overlay-trigger');

        for (let u = 0; u < overlayTriggers.length; u++) {
            overlayTriggers[u].addEventListener('click', function (e) {
                e.preventDefault();
                let currentTrigger = e.target.parentNode;
                if (currentTrigger.getAttribute('data-video-id') != null) {
                    novicell.overlay.create({
                        'videoId': currentTrigger.getAttribute('data-video-id'),
                        'type': currentTrigger.getAttribute('data-type'),
                        'class': 'js-overlay-trigger',
                        'autoplay': 1
                    });
                }
            });
        }
    };

    // Overlay for Markedplace 
    const overlayMarkedPlaces = document.querySelectorAll('.js-marked-place-overlay');

    for (let i = 0; i < overlayMarkedPlaces.length; i++) {
        const overlayMarkedPlace = overlayMarkedPlaces[i];

        const body = document.querySelector('body');

        // Get the button that opens the overlay 
        const triggerMarkedPlace = overlayMarkedPlace.parentNode.querySelector(".js-marked-place-overlay-trigger");

        // Get the <span> element that closes the overlay 
        const closeButton = overlayMarkedPlace.getElementsByClassName("close")[0];

        // When the user clicks on the button, open the overlay  
        triggerMarkedPlace.addEventListener('click', function (e) {
            const carousel = overlayMarkedPlace.querySelector(".main-carousel");
            e.preventDefault();
            overlayMarkedPlace.classList.add('open-overlay');
            overlayMarkedPlace.style.display = 'block';
            body.classList.add('no-scroll');

            let flkty = new Flickity(carousel, {
                contain: true,
                adaptiveHeight: true,
                pageDots: false,
                lazyLoad: true
            });

            // When the user clicks on <span> (x), close the overlay 
            closeButton.addEventListener('click', function () {
                flkty.destroy();
                body.classList.remove('no-scroll');
                overlayMarkedPlace.classList.remove('open-overlay');
            });

            // When the user clicks anywhere outside of the overlay, close it 
            overlayMarkedPlace.addEventListener('click', function (event) {
                if (event.target == this) {
                    flkty.destroy();
                    body.classList.remove('no-scroll');
                    this.classList.remove('open-overlay');
                }
            });
        });
    }

    // Overlay for forms
    const overlay = document.querySelector('.select-store-overlay');
    const body = document.querySelector('body');
    // Get the button that opens the overlay
    const trigger = document.querySelector(".js-select-store-trigger");

    if (overlay && trigger) {

        // Get the <span> element that closes the overlay
        const span = document.getElementsByClassName("close")[0];

        // When the user clicks on the button, open the overlay 
        trigger.onclick = function (e) {
            e.preventDefault();
            overlay.classList.add('open-overlay');
            body.classList.add('no-scroll');
        };

        // When the user clicks on <span> (x), close the overlay
        span.onclick = function () {
            body.classList.remove('no-scroll');
            overlay.classList.remove('open-overlay');
        };

        const checkboxes = document.querySelectorAll('.select-store-input');
        for (let i = 0; i < checkboxes.length; i++) {
            const checkbox = checkboxes[i];

            checkbox.onclick = function () {
                body.classList.remove('no-scroll');
                overlay.classList.remove('open-overlay');
            };
        }

        // When the user clicks anywhere outside of the overlay, close it
        window.onclick = function (event) {
            if (event.target == overlay) {
                body.classList.remove('no-scroll');
                overlay.classList.remove('open-overlay');
            }
        };
    }
}();
